import { clientLogger } from "../helpers/observability/logging";

const isTrue = (value) => ["1", "true", 1, true].includes(value);
const bettermodeSettings = window?.wvusBettermodeSettings || {};
const widgetConfig = bettermodeSettings.config?.widgetConfig || {};
const loggerInstance = clientLogger(bettermodeSettings.loggly_customer_key);

const appSettings = {
  ...bettermodeSettings,
  hasAuth0Acct: isTrue(bettermodeSettings.hasAuth0Acct),
  handshakeRequired:
    typeof widgetConfig.handshakeRequired !== "undefined"
      ? isTrue(widgetConfig.handshakeRequired)
      : true,
  badges: widgetConfig.badges || [],
  welcomeConfig: widgetConfig.welcomeConfig || {},
  surveyConfig: widgetConfig.surveyConfig || {},
  widgetId: bettermodeSettings.config?.widgetId,
  widgetType: bettermodeSettings.config?.widgetType,
  backgroundImageUrl:
    widgetConfig.backgroundImageUrl ||
    "https://wvusstatic.com/bettermode/registration-app/bettermode-registration-bg.jpg",
  successRedirectUrl:
    widgetConfig.successRedirectUrl ||
    "https://donateuat.worldvision.org/login?redirect_to=https://communityuat.worldvision.org?auth=true",
  wvusLogger: loggerInstance
};

export default appSettings;
